import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import {
  GSButton,
  GSCircleImage,
  GSInfoGroup,
} from "golfstatus_react_components";
import React from "react";
import {formatPhoneNumber} from "../../../helpers/Utilities";
import {displayHandicap} from "../../../helpers/Converters";

const TournamentTeamPlayerItem = (props) => {
  const { firstName, lastName, email, phone, avatar, removePlayer, flag, handicap, isHandicapScoring } = props;

  const defaultAvatar = "https://api.golfstatus.dev/images/user_round.png";

  const avatarInfo = {
    fit: "hide-mobile",
    sections: [
      {
        sectionItems: [
          {
            type: "secondary no-wrap full-width",
            value: <GSCircleImage size="large" url={avatar ?? defaultAvatar} />,
          },
        ],
      },
    ],
  };

  let groupInfoSectionItems = [{
    type: "primary no-wrap full-width capitalize",
    value: `${firstName} ${lastName} ${displayHandicap(handicap, isHandicapScoring)}`,
  }];

  if (email) {
    groupInfoSectionItems.push({
      type: "secondary no-wrap full-width",
      value: `${email ?? ""}`,
    });
  }

  if (phone) {
    groupInfoSectionItems.push({
      type: "secondary no-wrap full-width",
      value: `${formatPhoneNumber(phone) ?? ""}`,
    });
  }

  const groupInfo = {
    fit: "stretch",
    sections: [
      {
        sectionItems: groupInfoSectionItems,
      },
    ],
  };

  const actionsInfo = {
    sections: [
      {
        sectionItems: [
          {
            type: "secondary no-wrap full-width",
            value: (
              <GSButton
                buttonIcon={faTimesCircle}
                onClick={(e) => {
                  removePlayer?.({ ...props });
                  e?.stopPropagation?.();
                }}
              />
            ),
          },
        ],
      },
    ],
  };

  const proInfo = {
    sections: [
      {
        sectionItems: [
          {
            type: "primary no-wrap full-width",
            value: <GSButton type="secondary pill green" title="Pro" />,
          },
        ],
      },
    ],
  };

  const getGroup = () => {
    let group = [{ ...avatarInfo }, { ...groupInfo }];
    if (flag === "pro") {
      group.push({ ...proInfo });
    }
    if (removePlayer) {
      group.push({ ...actionsInfo });
    }
    return group;
  };

  return (
    <tournament-team-player-item>
      <GSInfoGroup dataGroups={getGroup()}></GSInfoGroup>
    </tournament-team-player-item>
  );
};

export default TournamentTeamPlayerItem;
